module.exports = __webpack_public_path__ + "img/user-default.48009f17.jpg";